// This is lifted from useReadAloud in the Monolith.
const wordSplittingRegEx =
  /(\d+[ ]+(?:\d+\/\d+)[.,!?):"%]*\s*|[\wñáéíóúü"èêôæ'’″(=+−-][-'/\wñáéíóúüèêôæ'’″⁰¹²³⁴⁵⁶⁷⁸⁹]*[.,!?):"%]*\s*)/gi;

export default wordSplittingRegEx;
